import { initializeApp } from "firebase/app";
import {
  getDatabase,
  ref,
  child,
  get,
  orderByChild,
  query,
  limitToLast,
} from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCqVSNU7tRoZvQ5sHaUIeO4ASCFShBLIdk",
  authDomain: "homepage-d40ae.firebaseapp.com",
  databaseURL: "https://homepage-d40ae.firebaseio.com",
  projectId: "homepage-d40ae",
  storageBucket: "homepage-d40ae.appspot.com",
  messagingSenderId: "134761004772",
  appId: "1:134761004772:web:83c33e80218c509a6936f1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export const firebaseFetchContents = async (lang = "ru") => {
  const dbRef = ref(database);
  const path = `${lang}/contents`;
  return get(child(dbRef, path)).then((snapshot) => snapshot.val());
};

export const firebaseFetchPostFeed = async (lang, page, per_page = 10) => {
  const dbRef = ref(database);
  const totalPosts = await get(child(dbRef, `${lang}/post-count`)).then(
    (snapshot) => snapshot.val()
  );
  const totalPages = Math.ceil(totalPosts / per_page);
  const postsRef = ref(database, `${lang}/posts`);

  try {
    // Fetch enough posts for all pages up to current (endAt is inclusive, so we slice client-side to avoid duplicates)
    const limit = page * per_page;
    const snapshot = await get(
      query(postsRef, orderByChild("date"), limitToLast(limit))
    );
    const allPagePosts = snapshot.val() || {};
    const sorted = Object.entries(allPagePosts)
      .map(([id, data]) => ({ id, ...data }))
      .sort((a, b) => new Date(b.date) - new Date(a.date));

    const start = (page - 1) * per_page;
    const posts = sorted.slice(start, start + per_page);

    return {
      totalPosts,
      totalPages,
      posts,
    };
  } catch (error) {
    console.error("Error getting posts:", error);
    throw error;
  }
};

export const firebaseFetchPost = async (tripId, lang = "ru") => {
  const dbRef = ref(database);
  const path = `${lang}/posts/${lang}-${tripId}`;
  return get(child(dbRef, path)).then((snapshot) => snapshot.val());
};

export const firebaseFetchPage = async (page, lang = "ru") => {
  const dbRef = ref(database);
  const path = `${lang}/${page}`;
  return get(child(dbRef, path)).then((snapshot) => snapshot.val());
};

/** Fetches all posts for a language for client-side search (id, title, preview, date, content). */
export const firebaseFetchAllPostsForSearch = async (lang = "ru") => {
  const dbRef = ref(database);
  const path = `${lang}/posts`;
  const snapshot = await get(child(dbRef, path));
  const val = snapshot.val();
  if (!val) return [];
  return Object.entries(val).map(([id, data]) => ({
    id,
    title: data.title || "",
    preview: data.preview || "",
    date: data.date || "",
    content: data.content,
  }));
};

export default app;
